export default "__VITE_ASSET__a4fded00__"